import { ColumnType, ReportCell, ReportColumn } from "@/types/evaluate";

export const useIsComplexCell = (cell: ReportCell, column: ReportColumn): boolean => {
  if (column.column_type === ColumnType.LLM_ASSERTION || column.column_type === ColumnType.HUMAN) {
    return true;
  }

  if (
    cell?.display_value?.type === "function" ||
    cell?.display_value?.type === "tool_calls" ||
    cell?.display_value?.type === "output_media" ||
    (cell?.display_value?.type === "object" &&
      (cell.display_value.value as { type?: string })?.type === "output_media") ||
    column.column_type === ColumnType.COMPARE ||
    cell?.display_value?.type === "unknown"
  ) {
    return true;
  }

  return false;
};
